function getLocalFiles(options) {
  return new Promise((resolve) => {
    const { allowMultiple = true, mimeTypes = [] } = options || {};
    const input = document.createElement("input");
    input.type = "file";
    input.accept = mimeTypes?.join(",");
    input.multiple = allowMultiple;
    async function onchange(e) {
      const fileList = e.target.files;
      if (!fileList || fileList.length === 0) return;
      const files = Array.from(fileList);
      input.value = "";
      resolve(files);
      input.removeEventListener("change", onchange);
      input.remove();
    }
    input.addEventListener("change", onchange);
    input?.click();
  });
}
export {
  getLocalFiles
};
//# sourceMappingURL=getLocalFiles.mjs.map
